import ReactFluidAnimation from './react-fluid-animation'
import FluidAnimation, { defaultConfig } from './fluid-animation'

export default ReactFluidAnimation
export { FluidAnimation, defaultConfig }
